export default __webpack_public_path__ + "static/media/use-template-to-enrich.56966df3.svg";